module.exports = new __parcel__URL__("shank.12c57ce0.png").toString();